import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import zIndex from "@mui/material/styles/zIndex";
import { borderRadius, borderRight, display, fontSize, fontWeight, lineHeight, textAlign } from "@mui/system";
import { thirdly4 } from "styles/theme";
import { bg } from "styles/theme";
import { dark } from "styles/theme";
import { thirdly2 } from "styles/theme";
import { thirdly } from "styles/theme";
import { secondary } from "styles/theme";

export const PerformAssessmentAgainStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({

}));

export const MicErrorsStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    rowGap: 8,
    '.error-item': {
        display: "flex",
        columnGap: 7,
        alignItems: "center"
    }
}));

export const RecordingStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    '.mic-canvas': {
        borderRadius: 35,
        border: '1px solid rgb(202, 211, 223)',
        marginTop: 20
    }
}));

export const IdleStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    '.check-mic': {
        width: 220,
        height: 220,
        '&:hover': {
            transform: 'scale(1.03)',
            cursor: "pointer"
        },
    },
    '.motion-content': {
        width: "100%",
        height: "100%",
    },
    '.content': {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));

export const TeacherIdleStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    rowGap: 24,
    paddingTop: 8,
    '.instructions': {
        width: "100%",
        textAlign: "center",
        fontSize: 20,
        whiteSpace: "pre-line"
    }
}));

// מסך "צריך לאפשר גישה למיקרופון" 
export const PermissionBlockedStyles = muiStyled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 12, // מצומצם כדי שהמסך ייכנס בגובה הקבוע)
    width: 612,
    maxWidth: "100%",
    color: "#26445A",
    fontFamily: "Calibri, sans-serif",
    fontSize: 16, // Body/Base
    textAlign: "center",
    '.pb-texts': {
        alignSelf: "stretch", // רוחב מלא - כדי ששלבים 1-2 יתיישרו לאותו קצה כמו שלב 3 (שמחוץ לבלוק הזה)
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: 4
    },
    '.pb-title': {
        fontSize: 25, // Title/XL
        fontWeight: 700,
        marginBottom: 4
    },
    // השלבים מיושרים לימין
    '.pb-step': {
        alignSelf: "stretch",
        textAlign: "start",
        paddingInlineStart: 4 // מיישר את השלבים עם הקצה הימני של התמונה  
    },
    '.pb-copy-link': {
        textDecoration: "underline",
        cursor: "pointer",
        fontWeight: 700
    },
    '.pb-img-wrap': {
        position: "relative",
        width: 604,
        maxWidth: "100%"
    },
    '.pb-highlight': {
        position: "absolute",
        top: 60,
        insetInlineEnd: 25,
        pointerEvents: "none"
    },
    '.pb-img': {
        display: "block",
        width: "100%",
        height: 135,
        objectFit: "cover",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)"
    },
    '.pb-button': {
        display: "flex",
        alignItems: "center",
        columnGap: 8,
        padding: "8px 16px",
        borderRadius: 8,
        background: "#325168",
        color: "white",
        cursor: "pointer",
        '&:hover': {
            opacity: 0.9
        },
        'i': {
            fontSize: 14 // הגןדל של האיקון קטן יותר
        }
    },
    '.pb-url': {
        fontSize: 11,
        direction: "ltr",
        wordBreak: "break-all",
        userSelect: "all"
    }
}));

// עטיפה לפופאפ בדיקת השמע של המורה - דורסת את הגדלים של מסכי הילד (טקסט 60/80, דמות 350 בפינה)
// "&&" מכפיל את הספציפיות כדי לגבור על CheckMicAndPermissionsStyles/ErrorStyles
export const TeacherMicCheckStyles = muiStyled(Box)(() => ({
    width: "100%",
    color: "#404F69",
    fontFamily: "Calibri, sans-serif",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    '&& > div': {
        width: "100%",
        flex: 1,
        alignItems: "flex-start",
        position: "relative"
    },
    '&& .cartoon-corner': {
        position: "absolute",
        insetInlineStart: 0,
        bottom: 0,
        width: "auto",
        height: 205,
        pointerEvents: "none"
    },
    '&& .cartoon-flow': {
        alignSelf: "flex-start",
        width: "auto",
        height: 202
    },
    '&& .teacher-texts': {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: 24,
        padding: "24px 0",
        width: "100%"
    },
    '&& .text-group': {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        rowGap: 8
    },
    '&& .refresh-btn': {
        width: 92,
        height: 92,
        borderRadius: "50%",
        background: "#FB7401",
        boxShadow: "-2.8px 2.58px 0 #91BDFA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        'svg': {
            width: 44,
            height: 44
        },
        'path': {
            fill: "white"
        }
    },
    '&& > div > div': {
        width: "100%"
    },
    '&& .text1, && .title': {
        fontSize: 25,
        fontWeight: 700,
        lineHeight: "normal"
    },
    '&& .text2, && .text': {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: "normal",
        textAlign: "center"
    },
    '&& .check-mic-teacher': {
        width: 165,
        height: 165,
        alignSelf: "center"
    },
    '&& .check-mic-teacher.clickable:hover': {
        transform: 'scale(1.03)',
        cursor: "pointer"
    },
    '&& .mic-canvas': {
        width: 140,
        height: 48,
        borderRadius: 24,
        border: "1px solid #CAD3DF",
        background: "white",
        margin: "16px 0"
    }
}));

export const ErrorStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    rowGap: 25,
    '.text': {
        fontSize: 30,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    },
    '.title': {
        fontWeight: "bold",
        fontSize: 50
    },
}));

export const SuccessStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%"
}));

export const CheckMicAndPermissionsStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '.skip-btn': {
        position: "absolute",
        bottom: 42,
        right: 32
    },
    '.text1': {
        fontSize: 60
    },
    '.text2': {
        fontSize: 80,
        fontWeight: "bold"
    },
    '.side-cartoon': {
        width: 350,
        height: 350,
        position: "absolute",
        bottom: 0,
        left: 0
    }
}));

export const OrangeButton = muiStyled(Box)(
    ({ theme, size = 200 }) => ({
        width: size,
        height: size,
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        position: 'relative',

        // 🎨 הגרדיאנט הראשי
        background: 'radial-gradient(circle at 30% 30%, #ff8c1a, #d65a00)',

        // 🌫 עומק פנימי
        boxShadow: `
      inset -6px -8px 12px rgba(0,0,0,0.25),
      inset 6px 6px 10px rgba(255,255,255,0.15)
    `,

        // ✨ היילייט
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '10%',
            right: '8%',
            width: '25%',
            height: '25%',
            borderRadius: '50%',
            // background: 'rgba(255, 200, 120, 0.7)',
            filter: 'blur(6px)',
        },

        // 🖱 hover (אופציונלי אבל נראה טוב)
        '&:hover': {
            transform: 'scale(1.03)',
        },

        // 👇 לחיצה
        //     '&:active': {
        //         transform: 'scale(0.97)',
        //         boxShadow: `
        //     inset -3px -4px 8px rgba(0,0,0,0.3),
        //     inset 3px 3px 6px rgba(255,255,255,0.1)
        //   `,
        //     },
    })
);

export const TooltipStyles = muiStyled(Box)(({ isHighGrade }) => ({
    '.on-off-icon': {
        height: 50,
        display: "flex",
        justifyContent: "end",
        position: "relative",
        right: -10
    },
    '.tooltip-content': {
        padding: 20,
        background: isHighGrade ? bg : "white",
        borderRadius: 16,
        zIndex: 1,
        fontSize: isHighGrade ? 25 : 17,
        lineHeight: 1.2,
        border: isHighGrade && `1px solid ${thirdly}`,
        boxShadow: isHighGrade ? `
    0 0 25px 4px rgba(76, 132, 255, 0.28),
    0 8px 20px rgba(0, 0, 0, 0.06)
    `
            : "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
}));

export const PreviewFinishPageStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: 15,
    height: "100%",
    '.record-item': {
        background: `${thirdly4} !important`,
        height: 87
    },
    '.record-title': {
        display: "flex",
        columnGap: 5
    },
    '.record': {
        width: "70%",
        padding: 10,
        borderRadius: 8,
        background: thirdly4
    },
    '.wrap-done': {
        background: secondary,
        width: 70,
        height: 70,
        borderRadius: 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    '.go-button': {
        borderRadius: "8px !important"
    },
    '.title': {
        fontWeight: "bold",
        marginBottom: 10
    },
    '.description': {
        textAlign: "center"
    }
}));

export const PreviewStyles = muiStyled(Box)(({ }) => ({
    position: "absolute",
    bottom: 30,
    '.wrap-preview': {
        border: `10px solid ${dark}`,
        width: 100,
        borderRadius: 100,
        height: 100,
        textAlign: "center",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: dark,
        background: "white",
        zIndex: 3
    },
    '.title': {
        fontWeight: "bold",
        fontSize: 22
    },
    '.description': {
        fontSize: 17
    }
}));

export const TooltipMessageStyles = muiStyled(Box)(({ }) => ({
    position: 'absolute',
    bottom: 48,
    right: 30,
    '.MuiSpeedDial-root': {
        alignItems: "end"
    },
    '.MuiButtonBase-root.MuiFab-root.MuiSpeedDial-fab': {
        background: thirdly,
        position: "relative",
        right: 5
    },
    '.MuiButtonBase-root.MuiFab-root.MuiSpeedDialAction-fab': {
        background: "white",
        padding: 20,
        borderRadius: 10,
        fontSize: 17,
        width: 400,
        height: 100,
        zIndex: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
    },
    '.tooltip-corner': {
        background: "white",
        right: 49,
        width: 20,
        height: 20,
        position: "absolute",
        top: 89,
        borderLeft: "1px solid #efefef",
        borderBottom: "1px solid #efefef",
        transform: "rotate(45deg)",
    },
}));

export const RatingListStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    '.rating': {
        height: 80,
        width: 80
    },
    display: "flex",
    columnGap: 22,
    width: "100%",
    justifyContent: "center",
}));

export const PerformAssessmentStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    background: "white",
    borderRadius: 15,
    '.description-tooltip': {
        zIndex: 11,
        position: "absolute",
        top: 35,
        right: 35
    },
    '.avatat-and-tooltip': {
        display: "flex",
        columnGap: 20
    },
    '.avatar': {
        width: 40,
        height: 40
    },
    '.ratings-complete-screen': {
        position: "absolute",
        top: 100,
        width: "100%",
        zIndex: 100
    },
    '.ratings-between-screen': {
        marginTop: 100,
        [theme.breakpoints.down('xl')]: {
            marginTop: 10,
        },
        [theme.breakpoints.down('lg')]: {
            marginTop: 40,
        }
    },
    '.between-animation': {
        width: "100%",
        height: "100%"
    },
    '.between-content': {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        rowGap: 5,
        height: "100%"
    },
    '.rating-img': {
        height: 190,
        widht: 190,
        marginBottom: 40,
        marginTop: 100,
        [theme.breakpoints.down('lg')]: {
            marginBottom: 10,
            marginTop: 10,
        },
    },
    '.between-title': {
        fontSize: 40,
        fontWeight: "bold"
    },
    '.between-sub-title': {
        fontSize: 30
    },
    '.between-img': {
        width: " 100%",
        height: "50%",
        position: "absolute",
        top: 8
    },
    '.wrap-waves-and-button': {
        display: "flex",
        columnGap: 10,
        alignItems: "center",
        padding: 10
    },
    '.waves': {
        border: "1px solid rgb(202, 211, 223)"
    },
    'canvas': {
        borderRadius: 35,
    },
    '.tooltip-fab': {
        position: "absolute",
        bottom: 53,
        right: 40
    },
    '.tooltip-corner': {
        background: "white",
        width: 20,
        height: 20,
        position: "absolute",
        top: 79,
        transform: "rotate(45deg)",
        borderBottom: "1px solid #e6e6e6",
        borderLeft: "1px solid #e6e6e6",
    },
    '.description-custom-tooltip': {
        position: "absolute",
        top: 15,
        right: 15,
        background: "white",
        padding: 20,
        borderRadius: 10,
        fontSize: 19,
        width: 300,
        height: 50,
        zIndex: 11,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
    '.perform-assessment-header': {
        position: "absolute"
    },
    '.wrap-assessment-details': {
        padding: "0px 15px",
        color: "rgb(202, 211, 223)",
        '.chip': {
            color: "rgb(202, 211, 223)",
            borderColor: "rgb(202, 211, 223)"
        }
    },
    '.MuiFab-root': {
        boxShadow: theme.shadows[1]
    },
    '.fab-button': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            position: "absolute",
            bottom: 70,
            right: 70
        }
    },
    '.play-pause-cartoon': {
        transform: "translateZ(0px)",
        flexShrink: 0,
        zIndex: 10,
        '.MuiButtonBase-root.MuiIconButton-root': {
            position: "absolute",
            bottom: 223,
            right: 371,
            background: thirdly2
        }
    },
    '.start-end-img': {
        width: 200,
        height: 200,
        cursor: "pointer",
        ':hover': {
            opacity: 0.8
        }
    }
}));

const fabButtonSize = {
    "large": {
        button: {
            width: 130,
            height: 130
        },
        icon: {
            width: 70,
            height: 70
        }
    },
    "medium": {
        button: {
            width: 100,
            height: 100
        },
        icon: {
            width: 50,
            height: 50
        }
    },
    "small": {
        button: {
            width: 70,
            height: 70
        },
        icon: {
            width: 30,
            height: 30
        }
    }
}

export const FabButtonStyles = muiStyled(Box)(({ size = "medium", fill, stroke, theme, $systemUI }) => ({
    '.MuiButtonBase-root.MuiIconButton-root': {
        ...fabButtonSize[size]?.button,
        background: secondary,
        'path': {
            stroke: stroke,
            fill: fill || "white"
        },
        'svg': {
            ...fabButtonSize[size]?.icon
        }
    }
}));

export const CheckPermissionStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '.wrap-fab-button': {
        top: 130,
        left: 100,
        position: "relative",
        [theme.breakpoints.down('lg')]: {
            left: 0
        },
        [theme.breakpoints.down('md')]: {
            left: -100
        },
    },
    '.check-permissions-img': {
        width: 600,
        height: 700
    },
    '.refresh-check-permissions-img': {
        display: "flex",
        alignItems: "center"
    },
    '.wrap-cartoon-and-button': {
        display: "flex",
        columnGap: 10
    }
}));


export const Step1Styles = muiStyled(Box)(({ pathHeight, pathWidth, cartoonMarginRight, theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    '.wrap-sun': {
        // marginLeft: 100
    },
    '.wrap-fab-button': {
        top: 180,
        left: 160,
        position: "relative",
        [theme.breakpoints.down('lg')]: {
            left: 0
        },
        [theme.breakpoints.down('md')]: {
            left: -100
        },
    },
    '.play-pause-cartoon .MuiButtonBase-root.MuiIconButton-root': {
        right: "222px !important",
        bottom: "200px !important"
    },
    '.path-img': {
        width: pathWidth || 1700,
        height: pathHeight || 200,
        position: "absolute",
        bottom: 70,
    },
    '.sun': {
        width: 500,
        height: 380,
        position: "absolute",
        top: 10,
        left: 450,
        zIndex: 1
    },
    '.cartoon-img': {
        width: 420,
        height: 420,
        position: "absolute",
        bottom: 40
    },
    '.wrap-cartoon-img': {
        marginRight: cartoonMarginRight
    },
    '.butterfly1': {
        width: 35,
        height: 35,
        position: "absolute",
        right: 300,
        top: 330
    },
    '.butterfly2': {
        width: 25,
        height: 25,
        position: "absolute",
        top: 150
    },
    '.butterfly3': {
        width: 30,
        height: 30,
        position: "absolute",
        top: 200,
        left: 500
    },
}));

export const Step2Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    height: "100%",
    justifyContent: "center",
    '.wrap-cartoon-img': {
        position: "absolute",
        top: 37,
        right: -80,
    },
    '.cartoon-img': {
        width: 500,
        height: 500,
        // position: "absolute",
    },
    '.wrap-content-with-cartoon': {
        display: "flex",
        alignItems: "center",
        width: "100%"
    },
    '.wrap-word-and-arrow': {
        display: "flex",
        width: "100%",
        justifyContent: "space-around",
        alignItems: "center"
    },
    '.side': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3
    },
    '.next-button': {
        position: "absolute",
        // bottom: 10
    },
    '.play-pause-cartoon': {
        '.MuiButtonBase-root.MuiIconButton-root': {
            bottom: 193,
            right: 171,
        }
    }
}));

export const Step3Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    '.wrap-fab-button': {
        top: 130,
        left: 100,
        position: "relative",
        [theme.breakpoints.down('lg')]: {
            left: 0
        },
        [theme.breakpoints.down('md')]: {
            left: -100
        },
    },
    '.wrap-cartoon-img': {
        // transform: 'translateZ(0px)',
        // flexShrink: 0,
        // zIndex: 3,
        // width: 0,
        // height: 800
    },
    '.cartoon-img': {
        width: 700,
        height: 700,
        // position: "absolute",
    },
    '.wrap-content': {
        display: "flex",
        alignItems: "center"
    },
    '.mic-img': {
        width: 100,
        height: 100
    }
}));

export const Step4Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
}));

export const Step5Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    '.finish-perform-img': {
        width: 500,
        height: 500
    }
}));

export const Step6Styles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",

}));
